(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "classnames", "ramda", "react", "react-jss", "./SpinnerIcon.style"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("classnames"), require("ramda"), require("react"), require("react-jss"), require("./SpinnerIcon.style"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames, global.ramda, global.react, global.reactJss, global.SpinnerIcon);
    global.SpinnerIcon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classnames, _ramda, React, _reactJss, _SpinnerIcon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _classnames = _interopRequireDefault(_classnames);
  React = _interopRequireWildcard(React);
  _SpinnerIcon = _interopRequireDefault(_SpinnerIcon);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var Icon = function Icon(props) {
    return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.9166666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(30 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.8333333333333334s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(60 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.75s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(90 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.6666666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(120 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.5833333333333334s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(150 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.5s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(180 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.4166666666666667s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(210 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.3333333333333333s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(240 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.25s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(270 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.16666666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(300 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.08333333333333333s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(330 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "0s",
      repeatCount: "indefinite"
    })));
  };
  Icon.defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70"
  };
  var useStyles = (0, _reactJss.createUseStyles)(_SpinnerIcon.default);
  var SpinnerIcon = function SpinnerIcon(_ref) {
    var className = _ref.className,
      small = _ref.small;
    var classes = useStyles();

    // Classes
    var rootClasses = (0, _classnames.default)(classes.root, className, _defineProperty({}, classes["root-small"], small));
    return /*#__PURE__*/React.createElement(Icon, {
      className: rootClasses
    });
  };
  var _default = _exports.default = (0, _ramda.compose)(React.memo)(SpinnerIcon);
});